import type { User } from '@supabase/supabase-js'
import type { KlantInfo, Geslacht } from '../types/booking'
import type { AppProfile } from '../services/profile'

/** Normaliseer `app_profiles.birth_date` naar ISO `YYYY-MM-DD`. */
export function normalizeGeboorteIso (
  birthDate: string | null | undefined
): string | undefined {
  if (!birthDate) return undefined
  const iso = birthDate.trim().slice(0, 10)
  if (!/^\d{4}-\d{2}-\d{2}$/.test(iso)) return undefined
  return iso
}

function mapProfileGeslacht (g: AppProfile['gender']): Geslacht | undefined {
  if (g === 'man' || g === 'vrouw' || g === 'anders' || g === 'liever_niet') return g
  return undefined
}

/** KlantInfo voor boeken/betalen vanuit auth + app_profiles. */
export function buildKlantInfoFromAppProfile (
  user: User | null,
  profile: AppProfile | null
): KlantInfo | null {
  const email = user?.email?.trim()
  if (!email) return null
  const meta = (user?.user_metadata ?? {}) as {
    voornaam?: string
    achternaam?: string
    telefoon?: string
  }
  const naam =
    profile?.displayName?.trim() ||
    [meta.voornaam, meta.achternaam].filter(Boolean).join(' ').trim() ||
    email.split('@')[0] ||
    'Klant'
  const telefoon = profile?.phone?.trim() || meta.telefoon?.trim() || ''
  const geslacht = mapProfileGeslacht(profile?.gender ?? null)
  const geboortedatum = normalizeGeboorteIso(profile?.birthDate)

  return {
    naam,
    email,
    telefoon,
    ...(geslacht !== undefined ? { geslacht } : {}),
    ...(geboortedatum ? { geboortedatum } : {}),
  }
}
